export default function shouldShowTabBarInReadingPane(
    showTabBarInListView: boolean,
    isDumpsterOrDumpsterSearchTable: boolean,
    isMyOutlookReadingPaneShowing: boolean
): boolean {
    return (
        !showTabBarInListView && !isDumpsterOrDumpsterSearchTable && !isMyOutlookReadingPaneShowing
    );
}
